import zlib from 'zlib';

export function gzipDecompress(compressed: string): string {
    return zlib.gunzipSync(new Buffer(compressed, 'base64')).toString();
}

export function gzipCompress(uncompressed: string): string {
    return zlib.gzipSync(uncompressed).toString('base64');
}
